import { Collapse, CollapseProps, Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { useStores } from "stores";
import { CommonTable } from "components";
import { getColumns } from "./getColumns";
import { routes } from "constants/routes";

export const CompanyContractList = observer(() => {
  const { companyContracts, user } = useStores();
  const navigate = useNavigate();

  const collapseItem: CollapseProps["items"] = [
    {
      key: "1",
      label: (
        <Typography.Text strong className="whitebox-title">
          Договоры
        </Typography.Text>
      ),
      children: (
        <Flex vertical gap="large">
          <CommonTable
            store={companyContracts}
            columns={getColumns(user)}
            updateWithInterval
            onRow={(record) => ({
              onClick: () => {
                navigate(`/${routes.contracts}/${record.id}`);
              },
              className: "cursor-pointer",
            })}
          />
        </Flex>
      ),
    },
  ];

  return <Collapse items={collapseItem} bordered={false} expandIconPosition="end" />;
});
